import React, { useState, useEffect, useContext, Component } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance, { weburl } from '../../axiosInstance';
import getDecryptData from '../../helper/getDecryptData';
import LoadingScreen from '../components/LoadingScreen';
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";


const ListingView = () => {
 
    
 const mydata = getDecryptData();
 const userId = mydata?._id;

  const [loading, setloading] = useState(true);

  const [Page, setPage] = useState({});
  const { id } = useParams();


  const getData = async () => {
 
    try {
      const { data } = await axiosInstance.get(`/get-user?userId=${id}`);
      const { success, token, existingUser, message } = data;
      setPage(existingUser);

      console.log('setPagesetPagesetPage',existingUser)
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }


  };




  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, [id]);

 



  return (
    <>
      <Header />
   
      <main className="page whitesmoke py-4">
   <div className="container " >

         {(!loading && Page ) ? 
       <>
 
   <div className="container my-4 my-lg-5">

      {/* TOP: IMAGE + BOOKING SIDEBAR */}
      <div className="row g-4">
        {/* LEFT MAIN CONTENT */}
        <div className="col-lg-8">

          {/* HERO IMAGE */}
          <div className="mb-0">
         
           {!loading && (
                           <>
                             <Swiper
                                
                               style={{
                                 "--swiper-navigation-color": "#ffff",
                                 "--swiper-pagination-color": "#ffff",
                               }}
                               spaceBetween={10}
                               navigation={true}
                                className={`mySwiper2 px-0 rounded-4`}
                             > 

                              {Page.images.map((image, index) => (
                                                 <SwiperSlide
                                                   key={index}
                                                    className=" px-0 py-2 d-block"
                                                 >    <img
                                                       src={image}
                                                      width="100%"
                                                       alt=""
                                                       className="w-100 rounded-4"
                                                     />
                                                  
                                                 </SwiperSlide>
                                               ))} 
 
                             </Swiper>
                          
                           </>
                         )}
         

          </div>

          {/* GYM TITLE CARD */}
          <div className="card border-0 shadow-sm mb-4 ">
            <div className="card-body d-flex align-items-start gap-3">
         
              {/* TEXT */}
              <div className="flex-grow-1">
                <h4 className="mb-1">{Page.username}</h4>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="fw-semibold text-success small d-flex align-items-center gap-1">
                    <i className="ri-star-fill" /> 4.4
                  </span>
                  <span className="small text-muted">• 5 Reviews</span>
                  <span className="small text-muted">• {Page.statename}</span>
                </div>
                <div className="small text-muted">
                  <i className="ri-map-2-line me-1" /> 
               {Page.address}
                </div>

                  {/* FOOTER BUTTONS */}
      <div className="d-flex gap-2 col-md-6 mt-4">
        <a
          href={Page.phone ? `tel:${Page.phone}` : "#"}
          className="btn btn-success text-dark flex-grow-1 d-flex align-items-center justify-content-center gap-2 rounded-3 py-2"
        >
          <i className="ri-phone-fill" />
          <span>Call Us</span>
        </a>

           <a
          href={Page.email ? `mailto:${Page.email}` : "#"}
          className="btn btn-dark text-white flex-grow-1 d-flex align-items-center justify-content-center gap-2 rounded-3 py-2"
        >
          <i className="ri-mail-fill" />
          <span>Email Us</span>
        </a>

</div>
              </div>
            </div>
          </div>

          {/* ABOUT US */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h5 className="mb-3">About Us</h5>
              <div dangerouslySetInnerHTML={{ __html: Page.about }} /> 
            </div>
          </div>

          {/* AMENITIES */}
         {Page.features &&  Page.features.length !== 0 &&   <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h5 className="mb-3">Amenities</h5>
              <div className="d-flex flex-wrap gap-2">
                   {Page.features.map((feature, index) => ( 
                    <span className="badge bg-light text-dark border px-3 py-2">
                  {feature.text}
                </span> ))}
           
              </div>
            </div>
          </div> }

          {/* MAP SECTION */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h5 className="mb-3">Location</h5>
              <div
                className="bg-light rounded-3"
                style={{ height: "260px" }}
              >
                {/* Replace with actual map embed */}
<iframe
  src={`https://www.google.com/maps?q=${encodeURIComponent(Page.location)}&hl=en&z=14&output=embed`}
  className="w-100 rounded-3"
  style={{ height: "260px", border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

                  
              </div>
            </div>
          </div>

          {/* REVIEWS */}
          <div className="card border-0 shadow-sm mb-4 d-none">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">5 Reviews</h5>
                <span className="badge bg-success-subtle text-success">
                  4.4 ★
                </span>
              </div>

              {/* Review item */}
              {[1, 2, 3, 4, 5].map((r) => (
                <div key={r} className="mb-3 pb-3 border-bottom">
                  <div className="d-flex justify-content-between">
                    <div>
                      <strong className="d-block">Member Name</strong>
                      <small className="text-muted">24 October 2022</small>
                    </div>
                    <span className="small text-success d-flex align-items-center gap-1">
                      <i className="ri-star-fill" /> 4.4
                    </span>
                  </div>
                  <p className="mb-0 mt-2 text-muted small">
                    I had been planning to hit the gym for quite some time and
                    then I saw this studio. The trainers are helpful, the
                    environment is motivating and equipment is well maintained.
                  </p>
                </div>
              ))}
            </div>
          </div>

         
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="col-lg-4">
       
       {/* HOW IT WORKS */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
                 
            <img src={weburl + Page.profile} className="rounded" />
            </div>
          </div>


          {/* FITPASS BENEFITS */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h6> FAQ's</h6>
             
              <div className="accordion" id="fitnessFaq">
              {Page.faqs.map((q, i) => (
                <div className="accordion-item" key={i}>
                  <h2 className="accordion-header" id={`heading-${i}`}>
                    <button
                      className={
                        "accordion-button " + (i !== 0 ? "collapsed" : "")
                      }
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-${i}`}
                      aria-expanded={i === 0 ? "true" : "false"}
                      aria-controls={`collapse-${i}`}
                    >
                      {q.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse-${i}`}
                    className={
                      "accordion-collapse collapse " + (i === 0 ? "show" : "")
                    }
                    aria-labelledby={`heading-${i}`}
                    data-bs-parent="#fitnessFaq"
                  >
                    <div className="accordion-body small text-muted">
                      {q.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            </div>
          </div>
 
        </div>
      </div>

      {/* OTHER STUDIOS NEARBY */}
      <section className="mt-5 d-none">
        <h5 className="mb-3">Other studios nearby</h5>
        <div className="row g-3">
          {[1, 2, 3, 4].map((c) => (
            <div key={c} className="col-md-3 col-sm-6">
              <div className="card border-0 shadow-sm h-100">
                <img
                  src="/assets/img/gym-thumb.jpg"
                  alt="Nearby studio"
                  className="card-img-top"
                  style={{ height: "150px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h6 className="mb-1 text-truncate">Spartans Gym</h6>
                  <div className="small text-muted mb-1">
                    2nd Floor, Market Road
                  </div>
                  <div className="d-flex align-items-center gap-2 small">
                    <span className="text-success d-flex align-items-center gap-1">
                      <i className="ri-star-fill" /> 4.7
                    </span>
                    <span className="text-muted">• 1.2 km</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

    
      {/* TRUST SECTION */}
      <section className="mt-4 mb-5 d-none">
        <div className="card border-0 shadow-sm">
          <div className="card-body d-flex flex-column flex-lg-row align-items-center justify-content-between gap-3">
            <div>
              <p className="mb-1 small text-muted">
                Trusted by customers across India
              </p>
              <h4 className="mb-0">4.7 ★</h4>
              <p className="mb-0 small text-muted">30K+ Ratings • 6M+ users</p>
            </div>
            <div className="text-center">
              <p className="mb-2 fw-semibold">Get FITPASS & get moving!</p>
              <div className="d-flex flex-column flex-sm-row gap-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Mobile No."
                  style={{ minWidth: "220px" }}
                />
                <button className="btn btn-danger">Send Link</button>
              </div>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <button className="btn btn-outline-dark btn-sm">
                  Download on App Store
                </button>
                <button className="btn btn-outline-dark btn-sm">
                  Get it on Play Store
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>

       </>
  
   : <LoadingScreen/> }


   </div>


      </main >
 
      <Footer />
    </>

  )
}

export default ListingView